/**
 * JSX Components for rendering Login/Logout links as well as the Agent Login link.
 *
 * @module
 */
import React from 'react';
import cx from 'classnames';
import { useAuth } from '../hooks';
/**
 * Will render a login button if sso is enabled and sso cookie exists.
 *
 * Otherwise will render a logout button.
 */
export const LoginLogoutLink = ({ className, loginClassName, logoutClassName, loginChildren, logoutChildren, ...props }) => {
    const { handleClick, ssoToken, isSSOEnabled, url } = useAuth();
    return isSSOEnabled ? (React.createElement("a", { ...props, className: cx(loginClassName && !ssoToken ? loginClassName : undefined, logoutClassName && !!ssoToken ? logoutClassName : undefined, className), onClick: handleClick, href: url }, ssoToken ? logoutChildren : loginChildren)) : null;
};
LoginLogoutLink.displayName = 'LoginLogoutLink';
/**
 * Will render a login button if sso is enabled and if an sso cookie exists.
 *
 * Otherwise will render a logout button.
 */
export const LoginLink = ({ className, children, ...props }) => {
    const { handleClick, isSSOEnabled, url } = useAuth({ onlyShowLogin: true });
    return isSSOEnabled ? (React.createElement("a", { ...props, className: className, onClick: handleClick, href: url }, children)) : null;
};
LoginLink.displayName = 'LoginName';
/**
 * Will render a login button if sso is enabled and if sso cookie exists.
 *
 * Otherwise will render a logout button.
 */
export const AgentLoginLogout = ({ className, loginClassName, logoutClassName, loginChildren, logoutChildren, ...props }) => {
    const { handleClick, ssoToken, isAgentLoginEnabled, url } = useAuth({
        agentLogin: true,
    });
    return isAgentLoginEnabled ? (React.createElement("a", { ...props, className: cx(loginClassName && !ssoToken ? loginClassName : undefined, logoutClassName && !!ssoToken ? logoutClassName : undefined, className), onClick: handleClick, href: url }, ssoToken ? logoutChildren : loginChildren)) : null;
};
AgentLoginLogout.displayName = 'AgentLoginLogout';
//# sourceMappingURL=auth.js.map